
export { useCookieYesConsent } from "/home/user/azagent2/_work/1/s/packages/utils/hooks/index.ts"